// Auto-generated per-query builders for GitHubRepo
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { GitHubRepoReadAPI, GitHubRepoWriteAPI, GitHubRepoReadAPISchema, GitHubRepoWriteAPISchema } from '../types/githubrepo';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, GitHubRepoOfOrganisation, ProjectUsesRepo, SoftwarePartRealizedByRepo } from '../../relationships/relationship';

import { SecurityScope } from '../../shared/api/securityscope';
import { Organisation } from '../../base/api/organisation';
import { Project } from './project';
import { SoftwarePart } from './softwarepart';





// Builder chain for query: rflp-github-repo-by-id

export interface RflpGithubRepoByIdBuilder_0 {
  get(id: string): RflpGithubRepoByIdBuilder_1;
  filter(conditions: { id: string }): RflpGithubRepoByIdBuilder_1;
}

export interface RflpGithubRepoByIdBuilder_1 {
  all(): Promise<GitHubRepo[]>;
  first(): Promise<GitHubRepo | null>;
  get(): Promise<GitHubRepo[]>;
  execute(): Promise<GitHubRepo[]>;
}

// Builder chain for query: rflp-organisation-github-repos

export interface RflpOrganisationGithubReposBuilder_0 {
  filter(conditions: { org_id: string }): RflpOrganisationGithubReposBuilder_1;
}

export interface RflpOrganisationGithubReposBuilder_1 {
  all(): Promise<GitHubRepo[]>;
  first(): Promise<GitHubRepo | null>;
  get(): Promise<GitHubRepo[]>;
  execute(): Promise<GitHubRepo[]>;
}


// Union of all query entry points
export type GitHubRepoQueryBuilder = RflpGithubRepoByIdBuilder_0 | RflpOrganisationGithubReposBuilder_0;

// Available query names for .setQuery()
export type GitHubRepoQueryNames = "rflp-github-repo-by-id" | "rflp-organisation-github-repos";

// Type narrowing for .setQuery()
export type GitHubRepoBuilderForQuery<Q extends GitHubRepoQueryNames> =
  Q extends "rflp-github-repo-by-id" ? RflpGithubRepoByIdBuilder_0
  : Q extends "rflp-organisation-github-repos" ? RflpOrganisationGithubReposBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type GitHubRepoInstanceQueryResult<Q extends GitHubRepoQueryNames> =
  Q extends "rflp-github-repo-by-id" ? RflpGithubRepoByIdBuilder_1
  : Q extends "rflp-organisation-github-repos" ? RflpOrganisationGithubReposBuilder_0
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-github-repo-by-id',
  'filter': 'rflp-organisation-github-repos',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends GitHubRepoQueryNames>(queryName: Q): GitHubRepoBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface GitHubRepo extends Partial<GitHubRepoReadAPI> {}
export class GitHubRepo extends NeoNodeBase<GitHubRepoReadAPI, GitHubRepoWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "GitHubRepo";
  static readonly readSchema = GitHubRepoReadAPISchema;
  static readonly writeSchema = GitHubRepoWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    organisation: { target: "Organisation", cardinality: "one", isParent: true, relClass: "GitHubRepoOfOrganisation", direction: "out" },
    used_by_projects: { target: "Project", cardinality: "many", isParent: false, relClass: "ProjectUsesRepo", direction: "in" },
    realizes_parts: { target: "SoftwarePart", cardinality: "many", isParent: false, relClass: "SoftwarePartRealizedByRepo", direction: "in" },
  };

  protected get modelName(): string {
    return 'GitHubRepo';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return GitHubRepo.label;
  }


  constructor(data: Partial<GitHubRepoWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: GitHubRepoReadAPI, loadContext?: Record<string, any>): GitHubRepo {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { security_scope, organisation, used_by_projects, realizes_parts, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = GitHubRepoReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, security_scope: security_scope, organisation: organisation, used_by_projects: used_by_projects, realizes_parts: realizes_parts };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return GitHubRepo.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'organisation', 'Organisation', ModelRegistry);
    loadManyRelationship(processed, 'used_by_projects', 'Project', ModelRegistry);
    loadManyRelationship(processed, 'realizes_parts', 'SoftwarePart', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new GitHubRepo(processed as any);

    return instance;
  }

  static filter(conditions: { org_id: string }): RflpOrganisationGithubReposBuilder_0;

  static filter(conditions: Record<string, any>): GitHubRepoQueryBuilder;

  static filter(conditions: Record<string, any>): GitHubRepoQueryBuilder {
    return new QueryBuilderImpl('GitHubRepo').filter(conditions) as any;
  }

  static all(): GitHubRepoQueryBuilder {
    return new QueryBuilderImpl('GitHubRepo') as any;
  }

  static async first(): Promise<GitHubRepo | null> {
    const results = await new QueryBuilderImpl('GitHubRepo').execute();
    return results[0] || null;
  }


  static setQuery<Q extends GitHubRepoQueryNames>(queryName: Q): GitHubRepoBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('GitHubRepo');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends GitHubRepoQueryNames>(queryName: Q): GitHubRepoInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = GitHubRepo.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'organisation' - Python ORM style (cached)
  get organisation(): RelationshipManager<this, Organisation> {
    return this.getOrCreateRelationshipManager('organisation', () => {
      return new RelationshipManager(this, 'organisation', 'one', GitHubRepoOfOrganisation as typeof Relationship);
    });
  }

  // Relationship manager for 'used_by_projects' - Python ORM style (cached)
  get used_by_projects(): RelationshipManager<this, Project> {
    return this.getOrCreateRelationshipManager('used_by_projects', () => {
      return new RelationshipManager(this, 'used_by_projects', 'many', ProjectUsesRepo as typeof Relationship);
    });
  }

  // Relationship manager for 'realizes_parts' - Python ORM style (cached)
  get realizes_parts(): RelationshipManager<this, SoftwarePart> {
    return this.getOrCreateRelationshipManager('realizes_parts', () => {
      return new RelationshipManager(this, 'realizes_parts', 'many', SoftwarePartRealizedByRepo as typeof Relationship);
    });
  }

}
